module.exports = __webpack_public_path__ + "static/media/presensi_pegawai.d5527566.png";